export default __webpack_public_path__ + "static/brownliving-1529e82c2c81ff0cd9b3afc4f13a7784.png";